import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref, computed, watch } from "vue";
  import { useStore } from "vuex";
  import { AnalyticsDataItem } from "@/types/AnalyticsDataInterface";
  import { EstateInterface } from "@/types/EstateInterface";
  import ChartForReports from "../reports/ChartForReports.vue";
  import { getAnalyticsData } from "@/helpers/analytics/getAnalyticsData";
  import getEstatesByLandowner from "@/helpers/analytics/getEstatesByLandowner";
  import { dataLotsOnClick } from "@/constants/dataForAnalytics";
  import { ReportsEstateSelected } from "@/enums/ReportsEstateSelected";
  import { ChartsTypes } from "@/enums/ChartsTypes";
  import SiteVisitorsFromAnalytics from "../reports/SiteVisitorsFromAnalytics.vue";
  import TimeSessionByUsersFromAnalytics from "./TimeSessionByUsersFromAnalytics.vue";
  import {
    optionsBarChartForWebsiteAnalytics,
    BackgroundColorForWebsiteAnalyticsLots,
    chartBackgroundColorForWebsiteAnalytics,
  } from "@/constants/optionsChart";
  import { useToast } from "vue-toastification";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'LotsOnClicksFromAnalytics',
  props: {
    startDate: {
      type: String,
      required: true,
    },
    endDate: {
      type: String,
      required: true,
    },
    searchKey: {
      type: Number,
      required: true,
    },
    estateSelected: {
      type: String,
      required: true,
    },
  },
  setup(__props, { expose: __expose }) {
  __expose();

  const props = __props;

  const loading = ref(false);
  const store = useStore();
  const toast = useToast();
  const DataFromAnalytics = ref<AnalyticsDataItem[]>([]);
  const estates = ref<EstateInterface[]>([]);

  const landownerId = computed(() => store.state.user.data._id);

  const startDateSelected = computed(() => {
    return props.startDate;
  });

  const endDateSelected = computed(() => {
    return props.endDate;
  });

  const estateSelected = computed(() => {
    return props.estateSelected;
  });

  watch(
    () => props.searchKey,
    () => {
      fetchDataFromAnalytics();
    }
  );

  const fetchDataFromAnalytics = async () => {
    await getAnalyticsData(
      startDateSelected.value,
      endDateSelected.value,
      dataLotsOnClick,
      DataFromAnalytics,
      loading,
      store,
      toast
    );
  };

  const fetchEstatesByLandowner = () => {
    getEstatesByLandowner(landownerId.value, estates);
  };

  const estatesByLandownerSelected = computed(() => {
    if (estateSelected.value === ReportsEstateSelected.ALL_PROJECTS) {
      return estates.value;
    }

    return estates.value.filter(
      (estate) => estate.title === estateSelected.value
    );
  });

  const filteredDataFromAnalytics = computed(() => {
    if (!estatesByLandownerSelected.value || !DataFromAnalytics.value.length) {
      return [];
    }

    return DataFromAnalytics.value.filter((estateByAnalytics) => {
      const [dim0, dim1, dim2, dim3] = estateByAnalytics.dimensionValues;
      const dim1Value = dim1.value;

      const estateTitleExists = estatesByLandownerSelected.value.some(
        (estate) => estate.title === dim1Value
      );

      return (
        dim2.value &&
        dim2.value !== "(not set)" &&
        estateTitleExists &&
        dim0.value === "lotOnClick" &&
        dim3.value !== "(not set)"
      );
    });
  });

  const transformedData = computed(() => {
    return filteredDataFromAnalytics.value.map((dataForAnalytics) => {
      const [dim0, dim1, dim2, dim3] = dataForAnalytics.dimensionValues;
      const [met0] = dataForAnalytics.metricValues;

      return {
        estate: dim1.value,
        stage: dim3.value,
        lot: dim2.value,
        clicks: met0.value,
      };
    });
  });

  const transformedDataByEstate = computed(() => {
    const uniqueEstatesSet = new Set(
      transformedData.value.map((data) => data.estate)
    );

    return Array.from(uniqueEstatesSet).map((currentEstate) => {
      const estateData = transformedData.value.filter(
        (data) => data.estate === currentEstate
      );

      const estateInfo = estates.value.find(
        (estate) => estate.title === currentEstate
      );

      const sortedEstateData = estateData
        .slice(0)
        .sort((a, b) => parseInt(b.clicks) - parseInt(a.clicks));

      const topFiveChartData = {
        lots: sortedEstateData.slice(0, 5).map((data) => data.lot),
        clicks: sortedEstateData
          .slice(0, 5)
          .map((data) => parseInt(data.clicks)),
        color: BackgroundColorForWebsiteAnalyticsLots,
      };

      const topFiveClickedLots = sortedEstateData.slice(0, 5);

      return {
        estate: currentEstate,
        estateId: estateInfo?._id,
        topFiveChartData,
        topFiveClickedLots,
      };
    });
  });

  onMounted(() => {
    fetchDataFromAnalytics();
    fetchEstatesByLandowner();
  });

const __returned__ = { props, loading, store, toast, DataFromAnalytics, estates, landownerId, startDateSelected, endDateSelected, estateSelected, fetchDataFromAnalytics, fetchEstatesByLandowner, estatesByLandownerSelected, filteredDataFromAnalytics, transformedData, transformedDataByEstate, onMounted, ref, computed, watch, get useStore() { return useStore }, get AnalyticsDataItem() { return AnalyticsDataItem }, get EstateInterface() { return EstateInterface }, ChartForReports, get getAnalyticsData() { return getAnalyticsData }, get getEstatesByLandowner() { return getEstatesByLandowner }, get dataLotsOnClick() { return dataLotsOnClick }, get ReportsEstateSelected() { return ReportsEstateSelected }, get ChartsTypes() { return ChartsTypes }, SiteVisitorsFromAnalytics, TimeSessionByUsersFromAnalytics, get optionsBarChartForWebsiteAnalytics() { return optionsBarChartForWebsiteAnalytics }, get BackgroundColorForWebsiteAnalyticsLots() { return BackgroundColorForWebsiteAnalyticsLots }, get chartBackgroundColorForWebsiteAnalytics() { return chartBackgroundColorForWebsiteAnalytics }, get useToast() { return useToast } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})